import React from "react";

import { Body } from "#app/components/texts/Typography";

import { SelectItem } from "#app/components/Calendar/styles";
import { useTaskTypesIcons } from "#app/pages/Relations/Contacts/hooks/useTaskTypesIcons";

interface SelectTypeProps {
    typeId: number | string;
    setType: (id: number) => void;
}

const SelectType: React.FC<SelectTypeProps> = ({ typeId, setType }) => {
    const { iconsList } = useTaskTypesIcons(typeId != null ? Number(typeId) : undefined);

    return (
        <div style={{ display: "flex", flexWrap: "wrap", margin: "10px 0" }}>
            {iconsList.map((type) => (
                <SelectItem
                    key={type.id}
                    className={typeId === type.id ? "active" : ""}
                    onClick={() => setType(Number(type.id))}
                >
                    {type.icon}
                    <Body>{type.text}</Body>
                </SelectItem>
            ))}
        </div>
    );
};

export default SelectType;
